import { uploadImage } from '../api/upload'

/** Generic placeholder for admin ImageUploadField (Arabic). */
export const ADMIN_IMAGE_FIELD_PLACEHOLDER =
  'path/to/image.jpg أو اسحب صورة (تُرفع عند الحفظ)'

/** Typical path prefix for shop logos. */
export const ADMIN_SHOP_IMAGE_PLACEHOLDER =
  'img/shops/some-image.jpg أو اسحب صورة (تُرفع عند الحفظ)'

/**
 * If the user picked a file in ImageUploadField, uploads it and returns the stored path.
 * Otherwise returns trimmed `values.imageUrl` or undefined.
 * Clears the ref's pending file after a successful upload.
 *
 * @param {object} values - form values with optional `imageUrl`
 * @param {React.RefObject} imageRef - ref to ImageUploadField
 * @returns {Promise<string|undefined>}
 */
export async function resolveAdminImageUrl(values, imageRef) {
  let imageUrl = values.imageUrl?.trim() || undefined
  const pendingFile = imageRef.current?.getPendingFile?.()
  if (pendingFile) {
    const { path } = await uploadImage(pendingFile, imageUrl || undefined)
    imageUrl = path
    imageRef.current?.clearPendingFile?.()
  }
  return imageUrl
}
